import { call, takeLatest, all, put } from '@redux-saga/core/effects';

import {
  SET_FINGERPRINT,
  POST_TRACKING_DETAILS,
} from '../actions/affiliate/affiliateActionConstants';
import {
  setFingerprintRequest,
  saveTrackingDetailsRequest,
} from '../../request/affiliateRequest';
import {
  setFingerprintSuccess,
  setFingerprintError,
  postTrackingDetailsSuccess,
  postTrackingDetailsError,
} from '../actions/affiliate/affiliateActions';
import { rejectErrorCodeHelper } from '../../util/helpers/rejectErrorCodeHelper';

// Set fingerprint
function* setFingerprint({ payload }) {
  try {
    yield call(setFingerprintRequest, payload);
    yield call(setFingerprintSuccess);
    yield call(setFingerprintError, '');
  } catch (error) {
    console.log(error); // eslint-disable-line
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield call(setFingerprintError, errorMessage);
  }
}
function* saveTrackingDetails({ payload }) {
  try {
    const response = yield call(saveTrackingDetailsRequest, payload.data);
    yield put(postTrackingDetailsSuccess(response.data));
    yield put(postTrackingDetailsError(''));
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(postTrackingDetailsError(errorMessage));
  }
}

export default function* accountSaga() {
  yield all([
    takeLatest(SET_FINGERPRINT, setFingerprint),
    takeLatest(POST_TRACKING_DETAILS, saveTrackingDetails),
  ]);
}
